import React from "react"
import type { FC } from "react"

export const GridItem: FC = props => {
  return <div {...props} />
}
